<template>
<v-layout style="margin: 0px; margin-top: 2px" class="small-text" column wrap>
    <v-card style="padding: 8px 8px 8px 8px;">     
         <v-flex shrink justify-start>
        <v-row justify="space-between">
          <v-row><v-flex shrink>
            <b class="taxi-list-header">Online:</b>
            {{ onlineTaxiCount }}&nbsp;&nbsp;&nbsp;
          </v-flex>
          <v-flex shrink>
            <b class="taxi-list-header">Free:</b>
            {{ freeTaxiCount }}
          </v-flex>
          </v-row>
          <v-flex shrink v-if="!toggleDisabled">
            <v-btn @click="showZones" style="height: 12px; -webkit-box-shadow: none;" x-small>Ride Types</v-btn>
          </v-flex>
        </v-row>
      </v-flex>
        <v-flex
          style="font-size: 14px;"
          pb-1
          v-if="taxisForZone(zone.id).length > 0"
          xs12
          v-for="zone in zones"
        >
          <v-layout row wrap>
            <span style="padding-right: 12px;">
              <b class="taxi-list-header">{{zone.name}}:</b>
              {{taxisForZone(zone.id).length}}
            </span>
            <div
              v-for="item in taxisForZone(zone.id)"
              @click="setSelectedTaxi(item.id)"
              style="cursor: pointer;"
            >
              <v-menu right offset-x :close-on-content-click="false" v-model="menu[item.id.toString()]">
                <template v-slot:activator="{ on }">
                  <div @click="showMenuForTaxi(item.id)" style="padding-top: 2px; margin-left: 4px; margin-bottom: 4px;">
                    <span v-bind:style="selectedTaxiStyle(item)" v-on="on" v-html="stateForTaxi(item)"></span>
                  </div>
                </template>
                <DriverMenu 
                  @editBooking="editActiveBookingForTaxi(item)"
                   @message="message" :taxi="item" @close="menu[item.id.toString()] = false" />
              </v-menu>
            </div>
          </v-layout>
        </v-flex>
        <v-flex style="font-size: 14px;" xs12>
          <v-layout row wrap>
            <span style="padding-right: 12px;">
              <b class="taxi-list-header">OOZ</b>
              {{taxisForZone(undefined).length}}
            </span>
            <div
              v-for="item in taxisForZone(undefined)"
              @click="setSelectedTaxi(item.id)"
              style="cursor: pointer"
            >
              <v-menu right offset-x :close-on-content-click="false" v-model="menu[item.id.toString()]">
                <template v-slot:activator="{ on }">
                  <div @click="showMenuForTaxi(item.id)" style="padding-top: 2.0px; margin-left: 4px;">
                    <span v-bind:style="selectedTaxiStyle(item)" v-on="on" v-html="stateForTaxi(item)"></span>
                  </div>
                </template>
                <DriverMenu 
                  @editBooking="editActiveBookingForTaxi(item)"
                  @message="message" :taxi="item" @close="menu[item.id.toString()] = false" />
              </v-menu>
            </div>
          </v-layout>
        </v-flex>
        <v-dialog v-model="messageDialog" width="600px">
          <MessageDriverDialog @sent="messageDialog = false" :taxi="taxi" />
        </v-dialog>
      </v-card>
  </v-layout>
</template>

<script>
import DriverMenu from "@/components/widget/menu/DriverMenu.vue";

import { Overwatch } from "@/components/util/Overwatch.js";
import MessageDriverDialog from "@/components/widget/menu/MessageDriverDialog.vue";

export default {
  name: "zone_list",
  components: {
    DriverMenu,
    MessageDriverDialog
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    toggleDisabled: {
      type: Boolean,
      default: false
    },
    taxis: Array,
    bookings: Array,
    rideTypes: Array,
    rideTypeEtas: Object,
    setSelectedTaxi: Function,
    selectedTaxi: Number,
    zones: Array
  },
  computed: {
     onlineTaxiCount: function() {

      var count = 0;

      for (var i = 0; i < this.taxis.length; i++) {
        if (this.taxis[i].offline == null || this.taxis[i].offline == false) {
          count++;
        }
      }

      return count;
    },
    freeTaxiCount: function() {
      var count = 0;

      for (var i = 0; i < this.taxis.length; i++) {
        if (this.taxis[i].state == 'available') {
          count++;
        }
      }

      return count;
    }
  },
  watch: {
    menu: {
      deep: true,
      handler() {
        console.log("PRESSED")
        console.log(this.menu);

        for (var i = 0; i < this.menu.length; i++) {
          if (this.menu[i] == true) {
            console.log( i );

            this.setSelectedTaxi( i );

            return;
          }
        }

        this.setSelectedTaxi( -1 );
      
      }
    }
  },
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
      menu: [],
      messageDialog: false,
      taxi: null
    };
  },
  methods: {
    editActiveBookingForTaxi(taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);

      var job = ow.getJobForTaxi(taxi.id);

      if (job != null) {
        this.$emit("editBooking", job.id)
      }

      return null;
    },
    showZones: function() {
      this.$emit("showZones")
    },
    message: function(taxi) {
      console.log("Message dialog");
      this.messageDialog = true;
      this.taxi = taxi;
    },
    showMenuForTaxi: function(id) {
      console.log("Show menu for taxi " + id);
      this.menu[id.toString()] = true;
    },
    colorForRideTypeEta: function(rideType) {
      return {
        color:
          this.rideTypeEtas["ride_type_" + rideType.id] >
          rideType.availability_warning_threshold
            ? "lightcoral"
            : "limegreen"
      };
    },
    selectedTaxiStyle: function(taxi) {
      var style = {
        padding: "2px",
        borderRadius: "6px",
        border: "1px solid #dadada",
      };

      if (taxi.id == this.selectedTaxi) {
        style.color = "white";
        style.backgroundColor = "black";
      } else {
        var ow = new Overwatch(this.taxis, this.bookings);

        style.color = "black";
        style.backgroundColor = ow.colorForTaxi(taxi);
      }

      return style;
    },
    stateForTaxi: function(taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);

      return ow.stateForTaxi(taxi, this.$store.state.driverGroups);
    },
    taxisForZone: function(id, count) {
      if (this.taxis == null) {
        return [];
      }

      var ow = new Overwatch(
        this.taxis,
        this.bookings,
        this.$store.state.use_zone_based_dispatch
      );

      return ow.sortTaxisByState(
        this.taxis.filter(function(t) {
          return t.zone == id;
        })
      );
    },
    bookingsForZone: function(id) {
      if (this.bookings == null) {
        return [];
      }

      return this.bookings.filter(function(b) {
        return b.ride_type == id;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  // color: green;
  font-weight: 800;
}

.small-text {
  font-size: 13px;
}
</style>
